export var LeftMenuState;
(function (LeftMenuState) {
    LeftMenuState[LeftMenuState["Unknown"] = 0] = "Unknown";
    LeftMenuState[LeftMenuState["Collapsed"] = 1] = "Collapsed";
    LeftMenuState[LeftMenuState["Expanded"] = 2] = "Expanded";
})(LeftMenuState || (LeftMenuState = {}));
